export interface LoadCarrierGroupType {
  loadCarrierGroupTypeId: number;
  name: string;
}
